// Extracts the nodes from a GQL connection into an array, filtering out null edges/nodes.
export function getNodesFromConnection<Node>(
  connection?: {
    edges: ({ node: Node | null } | null)[] | null;
  } | null,
): Node[] {
  return connection?.edges?.filter(e => e?.node).map(e => e!.node!) ?? [];
}
